
import { Component, Mixins, Prop } from "vue-property-decorator";
import { ReceptionDispInfo } from "../../../../../domain/workflow";
import { ReceptionDetail, ReceptionCommentSet } from "../../../../../domain/workflow/reception";
import { ReceptionCommentUnitKinds, ReceptionCommentSortItemKinds, } from "../../../../../domain/workflow/kinds";
import CommentDialog from "../../../dialogs/CommentDialog.vue";

@Component({
  components: {
    CommentDialog,
  }
})
export default class CommentReferenceMixin extends Mixins() {
  @Prop()
  commentDialog: CommentDialog;

  @Prop()
  labelSetting: ReceptionDispInfo;

  @Prop()
  commentUnitKind: ReceptionCommentUnitKinds;

  @Prop()
  nextMessageUnitKind: ReceptionCommentUnitKinds;

  @Prop()
  commentDefaultSortType: ReceptionCommentSortItemKinds;

  @Prop()
  shouldSortCommentAsc: boolean;

  @Prop({ default: false })
  isQuoted: boolean;

  async showCommentDialog(source: string, title: string, write: (text: string) => void): Promise<void> {
    const ret = await this.commentDialog.show({
      name: title,
      note: source,
    });
    if (!ret.isConfirmed) {
      return;
    }
    write(ret.note);
  }

  async showCommentDialogWithReferenceComment(source: string, title: string, write: (text: string) => void, detail: ReceptionDetail, isRegistered: boolean): Promise<void> {
    const commentSet = this.getCommentSet(detail, isRegistered);
    const ret = await this.commentDialog.show({
      name: title,
      note: source,
      shouldEmphasizeInput: false,
      reference: commentSet
        ? {
          labelSetting: this.labelSetting,
          comments: {
            defaultSortType: this.commentDefaultSortType,
            shouldSortCommentAsc: this.shouldSortCommentAsc,
            nextMessages: {
              unit: this.nextMessageUnitKind,
              comments: commentSet.nextMessages,
            },
            backMessages: {
              unit: this.commentUnitKind,
              comments: commentSet.backMessages,
            },
          },
        }
        : null,
    });
    if (!ret.isConfirmed) {
      return;
    }
    write(ret.note);
  }

  getCommentSet(detail: ReceptionDetail, isRegistered: boolean): ReceptionCommentSet {
    return !detail
      ? null
      : isRegistered || this.isQuoted
        ? detail.commentSet
        : this.shouldCreateCommentSet(detail)
          ? this.createCommentSet(detail)
          : null;
  }

  shouldCreateCommentSet(detail: ReceptionDetail): boolean {
    return !!detail.nextMessage && !!detail.nextMessage.content;
  }

  createCommentSet(detail: ReceptionDetail): ReceptionCommentSet {
    const commentSet = new ReceptionCommentSet();
    commentSet.comments.push(detail.comment);
    commentSet.restrictComments.push(detail.restrictComment);
    commentSet.nextMessages.push(detail.nextMessage);
    return commentSet;
  }
}
